export default {
  filters: {
    today: 'Hoy',
    yesterday: 'Ayer',
    this_week: 'Esta semana',
    last_week: 'Semana pasada',
    this_month: 'Este mes',
    last_month: 'Mes pasado',
    all: 'Todo',
  },
};
